// Minimal CSV writer. Deliberately hand-rolled rather than pulling in Papa
// Parse: that library is a parser first and we only ever write. The entire job
// here is escaping, and getting that right is about fifteen lines.
//
// Task titles are free text, so commas, quotes and newlines inside a field are
// routine rather than edge cases.
function escapeCell(value) {
  if (value === null || value === undefined) return ''
  const str = String(value)
  // Double any embedded quote, then wrap if the field contains anything that
  // would otherwise break the row or column boundaries.
  return /[",\n\r]/.test(str) ? `"${str.replace(/"/g, '""')}"` : str
}

export function toCsvRows(rows) {
  return rows.map(row => row.map(escapeCell).join(',')).join('\r\n')
}

// Multiple datasets in one file, each under a `# Section` comment row, which
// is friendlier than making someone download six files.
export function buildCsv({ meta = [], sections = [] }) {
  const blocks = []

  if (meta.length) blocks.push(toCsvRows(meta.map(([k, v]) => [`# ${k}`, v])))

  sections.forEach(({ name, headers, rows }) => {
    const block = [[`# ${name}`], headers, ...rows]
    blocks.push(toCsvRows(block))
  })

  return blocks.join('\r\n\r\n')
}

// The BOM is not optional in practice: without it Excel reads UTF-8 as the
// local codepage and mangles any non-ASCII task title.
export function downloadCsv(filename, content) {
  downloadBlob(filename, new Blob([`﻿${content}`], { type: 'text/csv;charset=utf-8;' }))
}

export function downloadJson(filename, data) {
  downloadBlob(filename, new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' }))
}

function downloadBlob(filename, blob) {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  // Revoked immediately: the download has already been handed to the browser,
  // and holding the object URL keeps the whole blob in memory.
  URL.revokeObjectURL(url)
}
